import type { PDFDocumentLoadingTask, PDFDocumentProxy, PDFWorker } from 'pdfjs-dist';

type PdfJs = typeof import('pdfjs-dist');

let shared: Promise<{ getDocument: PdfJs['getDocument']; worker: PDFWorker | undefined }> | null =
  null;
let open: { url: string; task: Promise<PDFDocumentLoadingTask> } | null = null;

const pdfjs = () => {
  shared ??= import('pdfjs-dist/webpack').then(
    ({ getDocument, GlobalWorkerOptions, PDFWorker }) => ({
      getDocument,
      worker: GlobalWorkerOptions.workerPort
        ? PDFWorker.fromPort({ port: GlobalWorkerOptions.workerPort })
        : undefined
    })
  );
  return shared;
};

const destroy = (task: Promise<PDFDocumentLoadingTask>) =>
  task.then((loading) => loading.destroy()).catch(() => undefined);

export const openPdf = (url: string): Promise<PDFDocumentProxy> => {
  if (open?.url !== url) {
    if (open) destroy(open.task);
    const task = pdfjs().then(({ getDocument, worker }) =>
      getDocument({ url, isEvalSupported: false, worker })
    );
    open = { url, task };
  }
  const { task } = open;
  return task
    .then((loading) => loading.promise)
    .catch((error) => {
      if (open?.task === task) open = null;
      throw error;
    });
};

export const closePdf = (url: string) => {
  if (open?.url !== url) return;
  destroy(open.task);
  open = null;
};
